import { connect } from "react-redux";
import SiteInspectionDetails from "./siteInspectionDetails";
import { bindActionCreators } from "redux";
import { inspectionApprovalDetails,inspectionPostSolution,inspectionReject} from "services/redux/approvals/salesApprovals/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  postReportDetails,
  generateReport,
} from "services/redux/installation/materialRequisition/action";
import {
  getInventory,
  postGateInventory,
} from "services/redux/installation/inventoryCheckList/action";
import { getMateriaById,getBrandById } from "services/redux/sales/postSales/corporate/action";

const mapStateToProps = (state) => ({
  siteData: state.salesApprovalReducer.insDetails,
  userProfile : state.loginReducer.userProfile,
  inventoryData: state.inventoryReducer.inventoryData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInventory,
      inspectionPostSolution,
      inspectionReject,
      getMateriaById,
      getBrandById,
      postGateInventory,
      inspectionApprovalDetails,
      documentUploadUrl,
      postReportDetails,
      generateReport
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteInspectionDetails);
